/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {withDLSTheme} from '../../theme/withDLSTheme';
import {SliderWrapper as CurrentSlider} from './current/Slider';
import LegacySlider from './legacy/Slider';

// This is essential if a client imports the `Slider` component using
// `import {Slider} from ‘./Slider’;`
export const Slider = withDLSTheme(LegacySlider, CurrentSlider);

export default Slider;
